/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function (a) {
  a.fn.prepareTransition = function () {
    return this.each(function () {
      var b = a(this);
      b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
        b.removeClass("is-transitioning")
      });
      var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
      var d = 0;
      a.each(c, function (a, c) {
        d = parseFloat(b.css(c)) || d
      });
      if (d != 0) {
        b.addClass("is-transitioning");
        b[0].offsetWidth
      }
    })
  }
})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e, r, a) {
  var n = new RegExp("(" + r + "=).*?(&|$)"), c = e;
  return c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a
};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') {
  Shopify = {};
}
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function (cents, format) {
    var value = '',
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $(document.body),

    // Navigation
    $navigation: $('#AccessibleNav'),
    $mobileSubNavToggle: $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView: $('.change-view'),

    // Product Page
    $productImage: $('#ProductPhotoBGImg'),
    $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink: $('#RecoverPassword'),
    $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
    $recoverPasswordForm: $('#RecoverPasswordForm'),
    $customerLoginForm: $('#CustomerLoginForm'),
    $passwordResetSuccess: $('#ResetSuccess'),

    fancyboxLockedOptions: {
      maxWidth: 960,
      maxHeight: '90%',
      /*  autoSize    : true,
       autoScale   : false,*/
      openEffect: 'fade',
      closeEffect: 'fade',
      scrolling: true,
      padding: 0,
      href: "#newsletter-popup",
      wrapCSS: 'fancybox-wrap--newsletter-popup',
      locked: true,
      closeBtn: false,

      helpers: {
        overlay: {closeClick: true}
      },
      afterLoad: function () {
        $('.fancybox-close-textual').on('click', function () {
          $.fancybox.close();
        });
      }
    },
    fancyboxOptionsNewsletter: {
      maxWidth: 700,
      maxHeight: '90%',
      /*  autoSize    : true,
       autoScale   : false,*/
      openEffect: 'fade',
      closeEffect: 'fade',
      scrolling: true,
      padding: 0,
      href: "#newsletter-confirm",
      wrapCSS: 'fancybox-wrap--newsletter-popup',
      locked: true,
      closeBtn: false,

      helpers: {
        overlay: {closeClick: true}
      },
      afterLoad: function () {
        $('.fancybox-close-textual').on('click', function () {
          $.fancybox.close();
        });
      }
    },
    fancyboxOptionsCheckout: {
      maxWidth: 700,
      maxHeight: '90%',
      /*  autoSize    : true,
       autoScale   : false,*/
      openEffect: 'fade',
      closeEffect: 'fade',
      scrolling: true,
      padding: 0,
      href: "#cart-checkout-popup",
      wrapCSS: 'fancybox-wrap--newsletter-popup',
      locked: true,
      closeBtn: false,

      helpers: {
        overlay: {closeClick: true}
      },
      afterLoad: function () {
        $('.fancybox-close-textual').on('click', function () {
          $.fancybox.close();
        });
      }
    },

    fancyboxOptions: {
      maxWidth: '800px',
     // minWidth: '80%',
      //maxHeight: '90vh',
      //autoSize: false,
      openEffect: 'fade',
      closeEffect: 'fade',
      scrolling: true,
      type: 'inline',
      padding: 0,
      closeBtn: true,
      wrapCSS: 'fancybox-wrap--product-video-popup',

      helpers: {
        overlay: {closeClick: true}
      },
      afterLoad: function () {
        $('.fancybox-close-textual').on('click', function () {
          $.fancybox.close();
        });
        setTimeout(function () {
          $('.fancybox-inner .product-video-popup video').trigger('play');
        }, 500)


      },
      afterClose: function () {

        $('.product-video-popup video').trigger('pause');
      }
    },
    fancyboxOptionsVacation: {
      maxWidth: '900px',
      openEffect: 'fade',
      closeEffect: 'fade',
      scrolling: true,
      type: 'inline',
      padding: 0,
      href: "#vacation-popup",
      closeBtn: true,
      wrapCSS: 'fancybox-wrap--newsletter-popup',

      helpers: {
        overlay: {closeClick: true}
      },
      afterLoad: function () {
        $('.fancybox-close-textual').on('click', function () {
          $.fancybox.close();
        });
        setTimeout(function () {
          $('.fancybox-inner .product-video-popup video').trigger('play');
        }, 500)


      },
      afterClose: function () {

        $('.product-video-popup video').trigger('pause');
      }
    }


  };
};

timber.init = function () {
  console.log('init');
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  timber.variantColorOptions();
  timber.apiFetch();
  timber.faq();


  // $(document).ready(function() {
  //   setTimeout(function() {
  //     timber.subscriptionButton();
  //   }, 300);
  // });

  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
  });

  //timber.instagram();
  if (wishlistpage != true || wishlistpage == undefined || wishlistpage == null) {
    //console.log('------------ tabs ----------------');
    timber.tabs();
  }

  timber.collectionFilterCollapse();

  timber.feefoAverage();

  $('.fancybox').fancybox(timber.cache.fancyboxOptions);
  $('.fancybox-checkout').fancybox(timber.cache.fancyboxOptionsCheckout);


  $('.accordion__trigger').on('click', function (e) {
    e.preventDefault();
    var $accordion = $(e.currentTarget).parent('.accordion');
    $accordion.toggleClass('active');
  });


  $.each($('.cta-banner-wrap'), function (index, element) {
    var $ctaBanner = $(element);
    var $closeTrigger = $ctaBanner.find('.cta-banner__close');
    var ctaBannerCookieId = 'blooms-and-blossoms-closed-ctabanner-' + $ctaBanner.data('id');
    if (!readCookie(ctaBannerCookieId)) {
      $ctaBanner.removeClass('cta-banner-wrap--closed');
    }
    $closeTrigger.on('click', function (e) {
      $ctaBanner.addClass('cta-banner-wrap--closed');
      createCookie(ctaBannerCookieId)
    });
  });

  //window.wishl_set_lang_code = "fr";

  console.log(window.wishl_set_lang_code);
// ==> in esign.js <==
  objectFitImages();

  //bij nog niet geantwoord op de vraag
  if (!readCookie('newsletter-blooms-blossoms-subscribed')) {
    $.fancybox(timber.cache.fancyboxLockedOptions);
    createCookie('newsletter-blooms-blossoms-subscribed', 'popup', 300);
  }
  //vacation-popup

/*
  var isBeforeEndDate = moment().isBefore('2019-10-06');

  if(isBeforeEndDate) {
    if (!readCookie('vacation-blooms-blossoms-2')) {
      $.fancybox(timber.cache.fancyboxOptionsVacation);
     // createCookie('vacation-blooms-blossoms-2', 'popup', 300);
    }
  }
*/

  if (readCookie('blooms-and-blossoms-cookies')) {
    $('.cookie-message').addClass('accepted');
  } else {
    $('.cookie-message').addClass('animated');
  }

  $('.accept-cookies').on('click', function () {
    $('.cookie-message').addClass('accepted');
    createCookie('blooms-and-blossoms-cookies', 'popup', 300);
  });

  $('.newsletter-form').on('submit',
    function () {

      parent.$.fancybox.close();
      setTimeout(function () {
        $('.newsletter-confirm-button').fancybox(timber.cache.fancyboxOptionsNewsletter);
        $('.newsletter-confirm-button').trigger('click');
      }, 500)

    });


  $('.cycle-slideshow').each(function (index) {
    $(this)
      .swipe({
        swipe: function (event, direction) {
          if (direction === 'left' || direction === 'up') {
            $(this).cycle('next');
          } else {
            $(this).cycle('prev');
          }
        }, allowPageScroll: "vertical"
      });
  });
  
	$(window).ready(function() {
        handleBeautyDealPopup();
    });
    function showPopup() {
        $('.bd-popup').closest().addClass('active');
    }


    function hidePopup() {
         $('.bd-popup').closest().removeClass('active');
    }

    function handleBeautyDealPopup() {
      $('.bd-popup, .bd-popup-show').on('mouseenter', function() {
      	$(this).next().addClass('active');
      });
      $('.bd-popup, .bd-popup-show').on('mouseleave', function() {
      	$(this).next().removeClass('active');
      });
      
      
    }

};

timber.getHash = function () {
  return window.location.hash;
};

timber.loopableObject = function (json) {
    return json.data ? json.data : json;
}

timber.apiFetch = function () {
  var truncate = function (text) {
    if(text) {
      var string = text.substring(0, 120);
      if (text.length > 120) {
        string += '&hellip;'
      }

      return string;
    } else {
      return '';
    }
  };

  $('.js-api-fetch').each(function() {
    var $this = $(this);
    var element = this;
    console.log(element);

    var template = element.querySelector('.json-fetcher__template');
    var keys = element.dataset.keys.split(';');
    var api = $this.data('api');
    var limit = $this.data('limit'); // optional limitation
    var itemClass = $this.data('item-class');



    $.ajax({
      url: api,
      data: {},
      dataType: 'json',
      success: function(data) {
        console.log(data);
        data = timber.loopableObject(data);
        timber.parseResults(data, template, keys, element);

      },
      error: function(err) {
        timber.printError(err);
      }
    });
  });
};

timber.parseResults = function (json, template,keys,element) {

    json.forEach(function(item) {
      const templateClone = template.cloneNode(true);
      keys.forEach(function(key) {
        try {
          const keyParts = key.split('.');
          let index = 0;
          let data = item;
          while (index + 1 <= keyParts.length) {
            data = data[keyParts[index]];
            index += 1;
          }
          templateClone.innerHTML = templateClone.innerHTML.replace('__'+ key + '__', data);
        } catch (error) {
          //printError(error);
        }
      });
      templateClone.innerHTML = templateClone.innerHTML.replace('data-src', 'src');
      element.appendChild(templateClone.children[0]);
    });
    template.parentNode.removeChild(template);

}


timber.variantColorOptions = function () {
  $('.color-option').on('click', function (e) {

    var $option = $(e.currentTarget);
    console.log($option);

    $('.color-option.active').removeClass('active');
    $option.addClass('active');
    var $productEl = $(e.currentTarget).parents('.js-product-wrap');
    var variant_id = $option.data('variant-id');
    var color_variant_handle = $option.data('variant-color-handle');
    var product_handle = $option.data('product-handle');
    var product_id = $option.data('product-id');
    var variant_image = $option.data('variant-image');
    if (variant_image) {
      if ($('#ProductPhotoImg').length) {
        $('#ProductPhotoImg').attr('src', variant_image);
      }

    }
  });
}


timber.feefoAverage = function () {
  $.get('https://api.feefo.com/api/10/reviews/summary/service?merchant_identifier=bloomsandblossoms', function (data) {

    if (data.rating.rating != undefined) {
      $('#feefo-service-average').html(data.rating.rating);
      $('#feefo-merchant-url').attr('href', data.merchant.review_url);
      $('.home-feefo-wrap').addClass('feefo-active');
    }

  });

  $.each($('.product-feefo-score-wrap'), function (index, element) {
    var $element = $(element);
    var product_id = $element.data('feefo-product-id');
    $.get('https://api.feefo.com/api/10/reviews/summary/product?merchant_identifier=bloomsandblossoms&parent_product_sku=' + product_id, function (data) {

      $element.find('.feefo-product-review-link').attr('href', data.product.reviews_url)

      var ratingProduct = data.rating.rating;

      if (ratingProduct != 0) {
        if (ratingProduct >= 3) {
          $element.addClass('feefo-active');
          $('#feefo-product-review-widgetId').addClass('feefo-active');
        }
      } else {
      }
    });

  });


};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
    $allLinks = $nav.find('a'),
    $topLevel = $nav.children('li').find('a'),
    $parents = $nav.find('.site-nav--has-dropdown'),
    $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
    activeClass = 'nav-hover',
    focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function (evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function () {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function (evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function () {
    handleFocus($(this));
  });

  $allLinks.blur(function () {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus($el) {
    var $subMenu = $el.next('ul'),
      hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
      isSubItem = $('.site-nav__dropdown').has($el).length,
      $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown($el) {
    $el.addClass(activeClass);

    setTimeout(function () {
      timber.cache.$body.on('touchstart', function () {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus($el) {
    $el.addClass(focusClass);
  }

  function removeFocus($el) {
    $el.removeClass(focusClass);
  }
};

// Tabs handler
timber.tabs = function () {

  var $tabPanels = $('.tabs__panel'),
    $tabPanelLinks = $('.tabs__panel-link');


  // hash
  var hash = window.location.hash.replace('#', ''),
    panelHash = '#tab-' + hash;
  if (hash !== "" && $(panelHash).length) {
    openPanel(panelHash);

    var offsetTop = $(panelHash).parents('.tabs').offset().top;
    $('html, body').scrollTop(offsetTop - 20);

  }

  // click
  $tabPanelLinks.click(function (e) {

    e.preventDefault();
    openPanel($(this).attr('href'));

  }).on('keydown', function (e) {
    // prev / next keys
    var $this = $(this),
      $parent = $this.parent(),
      $firstLink = $tabPanelLinks.first(),
      $lastLink = $tabPanelLinks.last();

    if (e.keyCode == 40 || e.keyCode == 39) {
      if ($parent.is(':last-child')) {
        $firstLink.click().focus();
      } else {
        $parent.next().find('.tabs__panel-link').click().focus();
      }
    } else if (event.keyCode == 37 || event.keyCode == 38) {
      if ($parent.is(':first-child')) {
        $lastLink.click().focus();
      } else {
        $parent.prev().find('.tabs__panel-link').click().focus();
      }
    }

  });

  function openPanel(panel) {
    // reset
    $tabPanels.attr('aria-hidden', true);
    $tabPanelLinks.attr({
      'aria-selected': 'false',
      'tabindex': -1
    }).removeClass('active');

    // current panel
    var $panel = $(panel),
      $panelLink = $tabPanelLinks.filter('[href="' + panel + '"]');

    $panel.removeAttr('aria-hidden');
    $panelLink.attr({
      'aria-selected': 'true',
      'tabindex': 0
    }).addClass('active');

   // location.hash = panel.replace('tab-', '').replace('#', '');
    langify.core.init()
  }

};

/* Generate Access token with http://instagram.pixelunion.net/ */

timber.instagram = function () {

  var $instagramWidget = $('.instagram-grid');
  if ($instagramWidget.length) {
    var accessToken = '6916011441.1677ed0.d84cf931de3d4ad49a2d1e3583e1b31b',
      userId = accessToken.substring(0, accessToken.indexOf('.')),
      feed_url = 'https://api.instagram.com/v1/users/' + userId + '/media/recent/?access_token=' + accessToken,
      items_to_load = 4;

    if (userId.length < 1) {
      return;
    }

    $.ajax({
      dataType: 'jsonp',
      url: feed_url,
      success: function (response) {
      }
    }).done(function (data) {
      console.log(data);

      var i, length = data.data.length, _results;

      if (length > items_to_load) {
        length = items_to_load;
      }


      _results = [];
      for (i = 0; i < length; i++) {
        _results.push($('.instagram-grid').append('<div class="grid__item one-half"><a class="item fade-link" target="_blank" href="' + data.data[i].link + '"><div class="" style="background-image:url(' + data.data[i].images.low_resolution.url + ')" /></div></a></div>'));
      }
      return _results;
    });

  }

};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
  timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': ajaxCart.load
  });
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function () {
    $(this).parent().toggleClass('mobile-nav--expanded');

  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
    variant = options.variant,
    selector = options.selector;

    if(!$('.color-options li').length) {
          $('#color-options-hr').hide();
          $('.color-options').hide();
    }


  //console.log($('#productSelectPromo').find('[data-variant="'+ variant.id +'"]'));
  $('#productSelectPromo').val(variant.id);
  //$('#productSelectPromo').find('[data-variant="'+ variant.id +'"]').attr('selected', true);
  //$('#productSelectPromo').attr('val', variant);


  // Selectors
  var $productImage = $('#ProductPhotoImg'),
    $productBGImage = $('#ProductPhotoBGImg'),
    $addToCart = $('.AddToCartClass'),
    $productPrice = $('.ProductPriceClass'),


    $comparePrice = $('#ComparePrice'),
    $quantityElements = $('.quantity-selector, label + .js-qty'),
    $addToCartText = $('#AddToCartText');


  $productImage.on('load',
    function () {
      $productBGImage.css('background-image', 'url("' + $productImage.attr('src') + '")');
    });

  if (variant) {

    $('.color-option').removeClass('active');
    $('.color-option[data-variant-id="' + variant.id + '"]').addClass('active');
    var usesColorOptions = $('.color-option').length;



    if(usesColorOptions) {

    var variantInfo = $('.color-option[data-variant-id="' + variant.id + '"]').data('variant-info');
    console.log(variantInfo);

       var descriptionWrapEl = $('#color-option-description')
    if(descriptionWrapEl.length) {
        descriptionWrapEl.find('.rte').html(variantInfo);

      if(variantInfo.length) {
      descriptionWrapEl.show();
      } else {
        descriptionWrapEl.hide();
      }

   }


    }


    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
        el = $productImage[0];

      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Toevoegen aan winkelwagentje");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Uitverkocht");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));
    //$productPricePromo.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("" +' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Niet beschikbaar");
    $quantityElements.hide();
  }
};

// timber.subscriptionButton = function() {
//   $(".bold-ro__recurring-text").after('<a href="#subscription-popup" class="fancybox subscription__info">?</a>');
// }

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function (evt) {
      evt.preventDefault();
      console.log('clicked thumbn');
      var newImage = $(this).attr('href');
      console.log(newImage);

      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  console.log($el);

  if ($(el).is('img')) {
    $el.attr('src', src);
    console.log('img');
  } else {
    console.log('bg');
    $el.css('background-image', 'url("' + src + '")');
  }
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};


function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  }
  else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

timber.collectionFilterCollapse = function () {
  if ($(window).width() < 767) {

    var $nav = $('.collection-sidebar__nav');
    var $activeNavItem = $nav.find('.filter--active');

    if ($activeNavItem.length == 0) {
      $activeNavItem = $nav.find('.collection-sidebar__nav__topclass');
      $activeNavItem.css('display', 'block');
      $activeNavItem.addClass('filter--active');
    }


    $nav.prepend($activeNavItem);

    $activeNavItem.on('click', function (e) {
      e.preventDefault();
      $('.collection-sidebar__nav').toggleClass('open');

    });

  }

  /*

    * */


};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function () {
      var view = $(this).data('view'),
        url = document.URL,
        urlWithoutHash = url.split('#')[0],
        hasParams = url.indexOf('?') > -1,
        location = '';

      if (hasParams) {
        location = replaceUrlParam(urlWithoutHash, 'view', view);
      } else {
        location = urlWithoutHash + '?view=' + view;
      }

      if (url.indexOf('#') > -1) {
        var hash = url.substring(url.indexOf('#') + 1);
        location += '#' + hash;
      }

      window.location = location;
    });
  }
};

timber.loginForms = function () {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function () {
  timber.cache.$passwordResetSuccess.show();
};


/*============================================================================
  Faq modules
==============================================================================*/
timber.faq = (function () {
  const items = document.querySelectorAll(".faq .faq__button");

  function toggleAccordion() {
    const itemToggle = this.getAttribute('aria-expanded');

    for (i = 0; i < items.length; i++) {
      items[i].setAttribute('aria-expanded', 'false');
    }

    if (itemToggle == 'false') {
      this.setAttribute('aria-expanded', 'true');
    }
  }

  items.forEach(item => item.addEventListener('click', toggleAccordion));
});



/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({disableExisting: true});
    this.$drawer.prepareTransition({disableExisting: true});

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  }
  else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Initialize Timber's JS on docready
$(timber.init);
